import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const VenueClockContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  gap: "2px",
  marginRight: "8px",
}));

export const VenueTimeLabel = styled("div")(({ theme }) => ({
  fontSize: "0.8rem",
  color: theme.palette.text.secondary,
  fontWeight: 500,
  textTransform: "uppercase",
  letterSpacing: "0.8px",
  opacity: 0.8,
}));

export const ClockTime = styled("div")(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: 500,
  color: theme.palette.text.primary,
  fontFamily: "monospace",
  letterSpacing: "0.5px",
}));


export const VenueTimeRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "baseline",
  gap: "8px",
  marginBottom: "1px",
}));

export const ClockTimezone = styled("div")(({ theme }) => ({
  fontSize: "0.7rem",
  color: theme.palette.text.primary,
  fontWeight: 500,
  opacity: 0.9,
}));
